import { render, staticRenderFns } from "./BulletinFileComponent.vue?vue&type=template&id=3b9a108a&scoped=true&"
import script from "./BulletinFileComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinFileComponent.vue?vue&type=style&index=0&id=3b9a108a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a108a",
  null
  
)

export default component.exports